import React from "react";
import { MDBTooltip } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import "./ui.css";

const EyeIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EditIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="0.7">
    <path d="M8.75 0.81L11.19 3.25L4 10.44H1.56V8L8.75 0.81Z" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const TrashIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
);

const MinusIcon = ({ color = "currentColor" }) => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <rect x="1" y="4.5" width="8" height="1" rx="0.5" fill={color} />
  </svg>
);

const CheckIcon = () => (
  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" aria-hidden="true">
    <path d="M1 3.5L3.5 6L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CloseIcon = () => (
  <svg width="6" height="6" viewBox="0 0 6 6" fill="none" aria-hidden="true">
    <path d="M1 1L5 5M5 1L1 5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

const VARIANT_ICONS = {
  view: EyeIcon,
  edit: EditIcon,
  delete: TrashIcon,
  success: CheckIcon,
  reject: CloseIcon,
  inactive: MinusIcon,
  active: MinusIcon,
};

const VARIANT_I18N_KEYS = {
  view: "view",
  edit: "edit",
  delete: "delete",
  branches: "branches",
  refresh: "refresh",
  transfer: "transfer",
  waitlist: "waitlist",
  "ready-for-delivery": "readyForDelivery",
  delivered: "DELIVERED",
  inactive: "inactive",
  active: "active",
};

function ActionButton({
  variant = "edit",
  children,
  icon,
  iconOnly = false,
  showIcon = true,
  disabled = false,
  type = "button",
  className = "",
  onClick,
  title,
  ...rest
}) {
  const { t } = useTranslation("translation");
  const IconComponent = VARIANT_ICONS[variant];
  const defaultLabel = VARIANT_I18N_KEYS[variant]
    ? t(VARIANT_I18N_KEYS[variant])
    : "";
  const label = iconOnly ? null : (children ?? defaultLabel);

  const classes = [
    "oh-action-btn",
    `oh-action-btn--${variant}`,
    iconOnly ? "icon-only" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const button = (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      title={disabled ? undefined : title}
      {...rest}
    >
      {showIcon && (icon || (IconComponent && (
        <span className="oh-action-btn__icon"><IconComponent /></span>
      )))}
      {label ? <span>{label}</span> : null}
    </button>
  );

  if (disabled && title) {
    return (
      <MDBTooltip tag="span" title={title}>
        <span className="oh-action-btn-tooltip-wrap">{button}</span>
      </MDBTooltip>
    );
  }

  return button;
}

export default ActionButton;
